export const getIsSafari = (): boolean => {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
